<div class="dashboard-edit-dialog-component">
  <h2 mat-dialog-title>{{ 'DASHBOARDPANEL.DIALOG-TITLE.UPDATE' | transloco }}</h2>

  <div mat-dialog-content>
    <dashboard-dashboard-edit
      #editChild
      [dashboard]="dashboard"
    ></dashboard-dashboard-edit>
  </div>

  <div mat-dialog-actions align="end">
    <cc-cancel-action-button (onClick)="close()"></cc-cancel-action-button>
    <cc-save-action-button
      [disabled]="!editChild?.form || editChild.form.invalid"
      (onClick)="save()"
    ></cc-save-action-button>
  </div>
</div>
